import PropTypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react';

import { Search } from 'lucide-react';
import { SimpleAlert, LoadingSpinner, DefaultTable, Input } from 'twyne-new.ui'

import { APP_PREFIX } from '@/utils/constants';

import { usePageStore } from '../store';

const propTypes = {
  pageId: PropTypes.number,
}

function PagePaths({ pageId }) {
  const [pagePaths, setPagePaths] = useState([])
  const [renderedItems, setRenderedItems] = useState([])
  const { loading, getPagePaths } = usePageStore()
  const [filter, setFilter] = useState('')

  const loadPaths = useCallback(async pageId => {
    const data = await getPagePaths(pageId)
    setPagePaths(data)
    setRenderedItems(data)
  }, [getPagePaths])

  useEffect(() => {
    if (pageId) {
      loadPaths(pageId)
    }
  }, [pageId, loadPaths])

  useEffect(() => {
    const normalizedFilter = filter.trim().toLowerCase()

    if (!normalizedFilter) {
      setRenderedItems(pagePaths)
      return
    }

    const filteredItems = pagePaths.filter(item => {
      const pathId = String(item.path_id ?? '')
      const pathName = String(item.path?.name ?? '').toLowerCase()

      return pathId.includes(normalizedFilter) || pathName.includes(normalizedFilter)
    })

    setRenderedItems(filteredItems)
  }, [filter, pagePaths])

  if (loading) {
    return <SimpleAlert>
      <div className='flex items-center gap-2'>
        Loading paths
        <LoadingSpinner />
      </div>
    </SimpleAlert>
  }

  if (!pagePaths?.length) {
    return <SimpleAlert>This page does not belong to any path.</SimpleAlert>
  }

  const columns = [
    {
      dataField: '',
      text: 'Path',
      formatter: (_, row) => <div onClick={() => window.open(`${APP_PREFIX}/path/paths/${row.path_id}`, '_blank')} className='cursor-pointer hover:underline twy-text-base-accent'>
        #{row.path_id} - {row.path.name}
      </div>,
    },
    {
      dataField: '',
      text: 'Slot',
      formatter: (_, row) => `${row.sort + 1}`,
      className: 'w-[10vh]',
    },

  ]

  return <>
    <div className='px-2 rounded-sm bg-gray-200 dark:bg-gray-950 relative w-full'>
      <Search size='18' className='absolute left-2 top-1/2 -translate-y-1/2 z-10 twy-text-base' />
      <Input
        name="filter"
        placeholder="Filter paths"
        className="border-0 w-full z-0 pl-6 bg-transparent"
        onChange={e => setFilter(e.target.value)}
        value={filter || ''}
      />
    </div>
    <DefaultTable
      data={renderedItems}
      columns={columns}
      className='max-h-[40vh] overflow-y-auto'
    />
  </>
}

PagePaths.propTypes = propTypes;

export default PagePaths;
